export default __webpack_public_path__ + "static/media/content2.7508fcfe.png";